import * as React from 'react';
import * as Cookies from 'js-cookie';
import {connect} from 'react-redux';
import {Button} from 'react-bootstrap';
import {SiteSettings} from '../model/base';
import * as Locale from '../model/locale';

@connect(
    state => ({
        user: state.data.user,
        textForKey: state.data.textForKey
    })
)


export class Banner extends React.Component<any, any> {
    constructor() {
        super();
        this.state = {
            showBanner: Cookies.get('cookieAck') !== 'true'
        };
    }

    hideBanner() {
        Cookies.set('cookieAck', 'true', {domain: SiteSettings.uri.host});
        console.log(SiteSettings.uri.host);
        this.setState({showBanner: false});
    }

    render() {
        let {textForKey} = this.props;
        let banner = null;
        if (this.state.showBanner) {
            let btn = (
                <Button type="button"
                        className={"button-close"}
                        onClick={() => {
                            this.hideBanner();
                        }}>
                    {textForKey(Locale.TEXT_COOKIE_BANNER_CLOSE)}
                </Button>
            );
            banner = (
                <div id="cookie-banner">
                    <div className="container">
                        <span className="cookie-message">
                            <h2>{textForKey(Locale.TEXT_COOKIE_BANNER_HEAD)}</h2>
                            <div className="content">
                                <p>{textForKey(Locale.TEXT_COOKIE_BANNER_CONTENT)}</p>
                                <a href="https://www.johnsoncontrols.com/legal/privacy"
                                   target={"_blank"}>{textForKey(Locale.TEXT_COOKIE_BANNER_POLICY_LINK)}</a>
                                {btn}
                            </div>
                        </span>
                    </div>
                </div>
            );
        }
        return <div>{banner}</div>;
    }
}
